import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import React, { memo, useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { useLocation, useParams } from "react-router-dom";
import { connect } from "react-redux";

// components
import Tabs from "./tabs";

import Navigator from "src/modules/3rd-party-management/components/navigator";

import Overview from "./tabs-content/overview";
import BasicInformation from "./tabs-content/basic-information";
import KYBTabContent from "./tabs-content/kyb";
import Findings from "./tabs-content/findings";
import Reports from "./tabs-content/reports";
import Communication from "./tabs-content/communication";
import InternalCommunication from "./tabs-content/internal-communication";
import RiskAssessment from "./tabs-content/risk-assessment";
import TaskMananger from "./tabs-content/task-manager";
import HistoryLog from "./tabs-content/history-log";
import FindingDetails from "./tabs-content/findings/components/details";
import Products from "./tabs-content/products";
import GeoCledianDetails from "./tabs-content/products/components/geo-cledian-details";
import CreateProductPage from "./tabs-content/products/components/create-eudr-product";
import Scoring from "./tabs-content/scoring";
import ReportQuestionnaire from "./tabs-content/reports/new";
import RelatedIncidents from "./tabs-content/related-incidents";
import { useQuery } from "@tanstack/react-query";
import SupplierService from "src/modules/3rd-party-management/apis/common/SupplierService";
import { toast } from "react-toastify";
import DdsStatementDetailPage from "./tabs-content/products/components/dds-statement-detail-page";
import AddKYBCompany from "./tabs-content/kyb/components/add-company";
import ComplianceMonitoring from "./tabs-content/compliance/monitoring/list";
import ComplianceScreening from "./tabs-content/compliance/screening/list";
import ScreeningResultDetails from "./tabs-content/compliance/screening/detail";
import MonitoringResultDetails from "./tabs-content/compliance/monitoring/detail";
import { KYBAvailableServices } from "src/modules/3rd-party-management/constants";

const detailsPageNavigatorOptions = {
    enable  :   true,
    backButtonOptions   :   {
        enable  :   true
    },
};

const TabContent = ({
    isLoading,
    supplierData,
    activeTab
}) => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    if(isLoading){
        return null;
    }

    switch(activeTab){
        case 'overview':
            return (
                <div className="bg-white p-4">
                    <Overview 
                        supplierData={supplierData}
                    />
                </div>
            )
        case 'basic-information':
            return (
                <div className="bg-white p-4">
                    <BasicInformation 
                        supplierId={supplierData.id} 
                    />
                </div>
            )
        case 'kyb': {
            const page = searchParams.get('page');

            if (page === 'add-company') {
                return (
                    <div>
                        <AddKYBCompany 
                            supplierData={supplierData}
                        />
                    </div>
                )
            }

            return (
                <div className="bg-white p-4">
                    <KYBTabContent 
                        supplierData={supplierData}
                    />
                </div>
            )
        }
        case 'compliance-monitoring': {
            const resultId = searchParams.get('id'); 

            if (resultId) {
                return (
                    <div>
                        <MonitoringResultDetails
                            id={resultId}
                            supplierId={supplierData.id}
                        />
                    </div>
                )
            }

            return (
                <div className="bg-white p-4">
                    <ComplianceMonitoring 
                        supplierId={supplierData.id}
                    />
                </div>
            )
        }
        case 'compliance-screening':{
            const resultId = searchParams.get('id'); 

            if (resultId) {
                return (
                    <div>
                        <ScreeningResultDetails
                            id={resultId}
                            supplierId={supplierData.id}
                        />
                    </div>
                )
            }

            return (
                <div className="bg-white p-4">
                    <ComplianceScreening 
                        supplierId={supplierData.id}
                    />
                </div>
            )
        }
        case 'scoring':
            return (
                <div className="bg-white p-4">
                    <Scoring supplierId={supplierData.id} />
                </div>
            )
        case 'products':{
            const productId = searchParams.get('id');
            const page = searchParams.get('page');

            if(page === 'statement') {
                return (
                    <div>
                        <DdsStatementDetailPage 
                            productId={productId}
                            supplierId={supplierData.id}
                        />
                    </div>
                )
            }

            if(page === 'geo') {
                return (
                    <div>
                        <GeoCledianDetails 
                            productId={productId}
                            supplierId={supplierData.id}
                        />
                    </div>
                )
            }

            if(page === 'create' || page === 'edit') {
                return (
                    <div>
                        <CreateProductPage 
                            productId={productId}
                            supplierId={supplierData.id}
                            industryIds={(supplierData.industries || []).map(industry => industry.id)}
                        />
                    </div>
                )
            }

            return (
                <div className="bg-white p-4">
                    <Products 
                        supplierId={supplierData.id} 
                    />
                </div>
            )
        }
        case 'findings':{
            const findingId = searchParams.get('id'); 

            if(findingId){
                return (
                    <div>
                        <FindingDetails
                            finding={{
                                id: findingId
                            }}
                            supplierId={supplierData.id}
                        />
                    </div>
                )
            }

            return (
                <div className="bg-white p-4">
                    <Findings 
                        supplierId={supplierData.id}
                    />
                </div>
            )
        }
        case 'reports':{
            const page = searchParams.get('page');

            if(page === 'questionnaire') {
                return (
                    <div className="bg-white p-4">
                        <ReportQuestionnaire 
                            supplierId={supplierData.id}
                        />
                    </div>
                )
            }

            return (
                <div className="bg-white p-4">
                    <Reports supplierId={supplierData.id} />
                </div>
            )
        }
        case 'related-incidents':
            return (
                <div className="bg-white p-4">
                    <RelatedIncidents supplierId={supplierData.id} />
                </div>
            )
        case 'communication':
            return (
                <div className="bg-white p-4">
                    <Communication supplierId={supplierData.id}/>
                </div>
            )
        case 'internal-communication':
            return (
                <div className="bg-white p-4">
                    <InternalCommunication supplierId={supplierData.id}/>
                </div>
            )
        case 'risk-assessment':
            return (
                <div className="bg-white p-4">
                    <RiskAssessment supplierId={supplierData.id} />
                </div>
            )
        case 'task-manager':
            return (
                <div className="bg-white p-4">
                    <TaskMananger supplierId={supplierData.id} />
                </div>
            )
        case 'history-log':
            return (
                <div className="bg-white p-4">
                    <HistoryLog supplierId={ supplierData.id } />
                </div>
            )
        default : return null
    }
}

const SupplierDetails = (props) => {
    const { t } = props;
    const location = useLocation();
    const { id } = useParams();
    const [ showTabs, setShowTabs ] = useState(true);
    
    const [ activeTab, setActiveTab ] = useState(null);

    const [ navigatorOptions, setNavigatorOptions ] = useState({
        enable              :   false,
        backButtonOptions   :   {},
        breadCrumbs         :   []    
    });

    const handleFetchSupplierBasicInformation = useQuery({
		queryKey: [
            '3rd-party-management-supplier-details-basic-infos',
            id
        ],
		queryFn: async () => {
			const service = SupplierService.getInstance();

            return await service.fetchBasicInfos(id, {});
		},
		cacheTime: 0,
		refetchOnWindowFocus: false,
		onError: (error) => {
			toast(t('An error occurred while fetching the basic information.'), {
				type: 'error',
			});
		}
	});

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);

        let rootPageLink = handleFetchSupplierBasicInformation?.data?.name ? (
            handleFetchSupplierBasicInformation.data.isOwnCompany ? 
                '/admin/3rd-party/manager/own' : 
                '/admin/3rd-party/manager?tab=suppliers' 
            ) : `/admin/3rd-party/suppliers/${id}/details?tab=overview`

        let breads = [
            {
                title   :   'TP Management',
                link    :   rootPageLink
            },
            {
                title   :   `${handleFetchSupplierBasicInformation?.data?.name || '...'}`,
                link    :   `/admin/3rd-party/suppliers/${id}/details?tab=overview`
            }
        ];

        const tabKey = searchParams.get('tab');

        switch(tabKey){
            case 'basic-information':
                    breads.push({
                        title   :   t('Basic Information'),
                        link    :   '#'
                    });
                break;
            case 'products':
                if(searchParams.has('id')){
                    breads = [...breads, {
                        title   :   'Products',
                        link    :   `/admin/3rd-party/suppliers/${id}/details?tab=products`
                    }, {
                        title   :   'Detail',
                        link    :   '#'
                    }];
                }
                else {
                    breads.push({
                        title: t('Products'),
                        link: '#'
                    });
                }
                break;
            case 'scoring':
                    breads.push({
                        title   :   t('Scoring'),
                        link    :   '#'
                    });
                break;
            case 'findings':
                if(searchParams.has('id')){
                    breads = [...breads, {
                        title   :   'Findings',
                        link    :   `/admin/3rd-party/suppliers/${id}/details?tab=findings`
                    }, {
                        title   :   'Detail',
                        link    :   '#'
                    }];
                }
                else{
                    breads.push({
                        title   :   t('Findings'),
                        link    :   '#'
                    });
                }
                break;
            case 'reports':
                    breads.push({
                        title   :   t('Reports'),
                        link    :   '#'
                    });
                break;
            case 'related-incidents':
                breads.push({
                    title   :   t('Related Incidents'),
                    link    :   '#'
                });
            break;
            case 'communication':
                    breads.push({
                        title   :   t('External Communication'),
                        link    :   '#'
                    });
                break;
            case 'internal-communication':
                    breads.push({
                        title   :   t('Internal Communication'),
                        link    :   '#'
                    });
                break;
            case 'risk-assessment':
                    breads.push({
                        title   :   t('Risk Assessment'),
                        link    :   '#'
                    });
                break;
            case 'task-manager':
                    breads.push({
                        title   :   t('Task Management'),
                        link    :   '#'
                    });
                break;
            case 'history-log':
                    breads.push({
                        title   :   t('History Log'),
                        link    :   '#'
                    });
                break;
            case 'kyb': 
                    if (searchParams.has('orgId')) {
                        const providerInfos = KYBAvailableServices.find((aServ) => aServ.id === searchParams.get('provider'));

                        breads = [
                            ...breads,
                            {
                                title: t('Company Info'),
                                link: `/admin/3rd-party/suppliers/${id}/details?tab=kyb`
                            }, 
                            {
                                title: `${providerInfos?.title} ${t('Report')}`,
                                link: '#'
                            }
                        ]
                    }
                    else {
                        breads.push({
                            title: t('Company Info'),
                            link: '#'
                        });
                    }
                break;
            case 'compliance-monitoring':
                if (searchParams.has('id')) {
                    breads = [
                        ...breads,
                        {
                            title: 'Compliance Monitoring',
                            link: `/admin/3rd-party/suppliers/${id}/details?tab=compliance-monitoring`
                        },
                        {
                            title: t('Detail'),
                            link: '#'
                        }
                    ]
                }
                else {
                    breads.push({
                        title: 'Compliance Monitoring',
                        link: '#'
                    });
                }
                break;
            case 'compliance-screening':
                if (searchParams.has('id')) {
                    breads = [
                        ...breads,
                        {
                            title: 'Compliance Screening',
                            link: `/admin/3rd-party/suppliers/${id}/details?tab=compliance-screening`
                        },
                        {
                            title: t('Detail'),
                            link: '#'
                        }
                    ]
                }
                else {
                    breads.push({
                        title: 'Compliance Screening',
                        link: '#'
                    });
                }
                break;
            default : 
                breads.push({
                    title   :   t('Overview'),
                    link    :   '#'
                });
                break;
        }

        const supplierName = handleFetchSupplierBasicInformation?.data?.name ? `${handleFetchSupplierBasicInformation.data.name}-ID: ${handleFetchSupplierBasicInformation.data.secondaryId}` : '...';

        setNavigatorOptions({
            ...detailsPageNavigatorOptions,
            breadCrumbs :   breads,
            pageTitle   :   supplierName
        });
    }, [ location.search, handleFetchSupplierBasicInformation.data ]);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);

        if(['findings', 'products', 'kyb', 'compliance-screening', 'compliance-monitoring'].includes(activeTab?.key) && (searchParams.has('page') || searchParams.has('id'))){
            setShowTabs(false);
        }
        else{
            setShowTabs(true);
        }
    }, [ location.search, activeTab ]);

    return (
        <div className='page-content supplier-details-page'>
            <Container fluid>
                <Row>
                    {
                        navigatorOptions.enable && (
                            <Col lg="12" className="mb-4">
                                <Navigator backButtonOptions={(props) => {
                                    return {
                                        ...props,
                                        ...navigatorOptions.backButtonOptions
                                    }
                                }} breadCrumbs={navigatorOptions.breadCrumbs} pageTitle={navigatorOptions.pageTitle}/>
                            </Col>
                        )
                    }

                    <Col lg="12" className="mb-4">
                        <div className="details-content-wrapper">
                            {showTabs && (
                                <Tabs 
                                    isLoading={
                                        handleFetchSupplierBasicInformation.isLoading ||
                                        handleFetchSupplierBasicInformation.isFetching
                                    }
                                    supplierData={handleFetchSupplierBasicInformation?.data}
                                    onActiveTabChange={({ tab }) => setActiveTab(tab)}
                                />
                            )}

                            <div>
                                <TabContent 
                                    isLoading={
                                        handleFetchSupplierBasicInformation.isLoading ||
                                        handleFetchSupplierBasicInformation.isFetching ||
                                        !activeTab
                                    }
                                    supplierData={handleFetchSupplierBasicInformation?.data}
                                    activeTab={activeTab?.key}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

const mapStatetoProps = (state) => {
    const { token } = state.Login;
    const { Organization } = state;
    return {
        user          :   state.Login.user,
        token         :   token,
        organization  :   Organization
    };
};

export default withNamespaces()(
    withRouter(connect(
        mapStatetoProps,
        {}
    )(memo(SupplierDetails)))
);